import React from 'react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { Pricing, FAQ, FinalCTA } from '../components/Sections';
import CampaignCredits from '../components/CampaignCredits';
import { CircleCheck } from 'lucide-react';

const compare = [
  { feature: 'WhatsApp multiatendimento', starter: true, business: true, enterprise: true },
  { feature: 'Instagram, Messenger, E-mail', starter: 'Até 3', business: 'Ilimitado', enterprise: 'Ilimitado' },
  { feature: 'Chatbot com fluxos visuais', starter: true, business: true, enterprise: true },
  { feature: 'CoreAI Copiloto (sugestões)', starter: false, business: true, enterprise: true },
  { feature: 'CoreAI Autônomo (24/7)', starter: false, business: 'Opcional', enterprise: 'Incluído' },
  { feature: 'Automações e workflows', starter: 'Básicos', business: 'Avançados', enterprise: 'Ilimitados' },
  { feature: 'SLA e roleta de tickets', starter: false, business: true, enterprise: true },
  { feature: 'API e Webhooks', starter: false, business: true, enterprise: true },
  { feature: 'SSO / SAML', starter: false, business: false, enterprise: true },
  { feature: 'Success Manager', starter: false, business: false, enterprise: true },
  { feature: 'Suporte', starter: 'Chat', business: 'Chat + Telefone', enterprise: 'Dedicado 24/7' },
];

const Cell = ({ v }) => (
  <td className="px-4 py-4 text-center">
    {v === true && <CircleCheck size={18} className="inline text-[#FF5B24]" />}
    {v === false && <span className="text-slate-300">–</span>}
    {typeof v === 'string' && <span className="text-sm text-slate-700 font-medium">{v}</span>}
  </td>
);

const Precos = () => (
  <>
    <Seo
      title="Planos e Preços"
      description="Planos da CoreDesk a partir de R$ 550/mês. Sem taxa de setup, 14 dias de trial e cancele quando quiser. Atendimento omnichannel com agentes de IA."
      path="/precos"
    />
    <Header />
    <PageHero
      eyebrow="Planos e preços"
      title="Preços |transparentes"
      subtitle="Sem taxa de setup, sem letras miúdas. Cancele quando quiser. Comece com 14 dias grátis em qualquer plano."
    />
    <Pricing />
    <CampaignCredits />

    <section className="py-20 bg-[#FAF6F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a0e27]">Compare os planos</h2>
          <p className="mt-3 text-slate-600">Encontre o plano ideal para o momento da sua operação.</p>
        </div>
        <div className="bg-white rounded-3xl shadow-lg border border-slate-100 overflow-hidden">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-6 py-4 text-xs font-bold uppercase tracking-widest text-slate-500">Recurso</th>
                <th className="px-4 py-4 text-xs font-bold uppercase tracking-widest text-slate-500">Starter</th>
                <th className="px-4 py-4 text-xs font-bold uppercase tracking-widest text-[#FF5B24]">Business</th>
                <th className="px-4 py-4 text-xs font-bold uppercase tracking-widest text-slate-500">Enterprise</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {compare.map((r) => (
                <tr key={r.feature}>
                  <td className="px-6 py-4 text-sm text-[#0a0e27] font-medium">{r.feature}</td>
                  <Cell v={r.starter} />
                  <Cell v={r.business} />
                  <Cell v={r.enterprise} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <FAQ />
    <FinalCTA />
    <Footer />
  </>
);

export default Precos;
